export const QuickApplyRoutes = {
    Index: 'vacancies/:id/apply',
};
